import React from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import KidexContainer from "./KidexContainer";
import leaderImg1 from "../../../Assets/landing-page/our-team-imgs/kapish-saraf.png";
import leaderImg2 from "../../../Assets/landing-page/our-team-imgs/amritanshu-kumar.png";
import leaderImg3 from "../../../Assets/landing-page/our-team-imgs/gaurav.jpeg";
import leaderImg4 from "../../../Assets/landing-page/our-team-imgs/rashi-nigam.jpeg";
import leaderImg5 from "../../../Assets/landing-page/our-team-imgs/bhavik.jpg";
import "swiper/swiper.min.css";

const OurTeam = () => {
   return (
      <React.Fragment>
         <section className="leadership-sec post-crousel outer-space">
            <div className="sec-main-heading no-margin">Our leadership team</div>
            <KidexContainer>
               <div className="ourleader-crousel swiper_wrap">
                  <Swiper
                     navigation={{
                        nextEl: '.next-ourleader-team',
                        prevEl: '.prev-ourleader-team',
                     }}
                     modules={[Navigation]}
                     loop={true}
                     spaceBetween={0}
                     breakpoints={{
                        320: {
                           spaceBetween: 8,
                           slidesPerView: 1,
                           loop: true
                        },
                        460: {
                           spaceBetween: 10,
                           slidesPerView: 1.2,
                           loop: true
                        },
                        480: {
                           spaceBetween: 10,
                           slidesPerView: 1.2,
                           loop: true
                        },
                        576: {
                           spaceBetween: 8,
                           slidesPerView: 2.2,
                           loop: true
                        },
                        768: {
                           spaceBetween: 8,
                           slidesPerView: 2.5,
                           loop: true
                        },
                        820: {
                           spaceBetween: 8,
                           slidesPerView: 3.5,
                           loop: true
                        },
                        960: {
                           spaceBetween: 8,
                           slidesPerView: 3.5,
                           loop: true
                        },
                     }}
                  >
                     <SwiperSlide className="post-crousel-crd-outer">
                        <div className="post-crosl-card leadership-crosl-card">
                           <div className="post-crosl-card-img">
                              <img src={leaderImg1} />
                           </div>
                           <p className="leadership-crosl-title">Kapish Saraf</p>
                           <span>IIT Kharagpur, IIM Calcutta</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="post-crousel-crd-outer">
                        <div className="post-crosl-card leadership-crosl-card">
                           <div className="post-crosl-card-img">
                              <img src={leaderImg2} />
                           </div>
                           <p className="leadership-crosl-title">Amritanshu Kumar</p>
                           <span>IIT Kharagpur, IIM Calcutta</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="post-crousel-crd-outer">
                        <div className="post-crosl-card leadership-crosl-card">
                           <div className="post-crosl-card-img">
                              <img src={leaderImg3} />
                           </div>
                           <p className="leadership-crosl-title">Gaurav Aggarwal</p>
                           <span>IIIT Hyderabad, Microsoft</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="post-crousel-crd-outer">
                        <div className="post-crosl-card leadership-crosl-card">
                           <div className="post-crosl-card-img">
                              <img src={leaderImg4} />
                           </div>
                           <p className="leadership-crosl-title">Rashi Nigam</p>
                           <span>VIT, MIT, Atal Tinkering Labs</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="post-crousel-crd-outer">
                        <div className="post-crosl-card leadership-crosl-card">
                           <div className="post-crosl-card-img">
                              <img src={leaderImg5} />
                           </div>
                           <p className="leadership-crosl-title">Bhavik Khurana</p>
                           <span>Intel, Atal Tinkering Labs</span>
                        </div>
                     </SwiperSlide>
                  </Swiper>
                  <div class="swiper-button-prev prev-ourleader-team"></div>
                  <div class="swiper-button-next next-ourleader-team"></div>
               </div>
            </KidexContainer>
         </section>
      </React.Fragment>
   );
};

export default OurTeam;
